/**
 * @generated SignedSource<<bab710ad373a1df29c1ed4ccf274df83>>
 * @relayHash 6e4788295a3521f95b872fd67f454a3a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 87faa53dad712d0b8ca311a2660442b81795f103c1ebc95501b4a89515a756fb

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { OrganizationDetailsOrganizationDetailsPageCsmQuery } from './OrganizationDetailsOrganizationDetailsPageCsmQuery.graphql';

import isAssetsFieldEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerContextRelayprovider';
import isAssetsFastFollowEnabled_provider from '@jira/platform__graphql-relay-provider/src/csmNativeAssetsFieldCustomerCtxFastFollowsRelayprovider';

const node: PreloadableConcreteRequest<OrganizationDetailsOrganizationDetailsPageCsmQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "87faa53dad712d0b8ca311a2660442b81795f103c1ebc95501b4a89515a756fb",
    "metadata": {},
    "name": "OrganizationDetailsOrganizationDetailsPageCsmQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerContextRelayprovidertsx": isAssetsFieldEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrccsmNativeAssetsFieldCustomerCtxFastFollowsRelayprovidertsx": isAssetsFastFollowEnabled_provider
    }
  }
};

export default node;
